export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: "social" | "entertainment" | "tech";
  coverImage: string;
  author: string;
  publishedAt: string;
  viewCount: number;
  likeCount: number;
  isFeatured: boolean;
  isHot: boolean;
}

export interface Comment {
  id: string;
  articleId: string;
  author: string;
  authorAvatar: string | null;
  content: string;
  createdAt: string;
  likes: number;
}

export const categoryMap: Record<string, { name: string; icon: string; color: string }> = {
  social: { name: "社会热点", icon: "ri-fire-line", color: "accent" },
  entertainment: { name: "娱乐八卦", icon: "ri-star-line", color: "primary" },
  tech: { name: "科技资讯", icon: "ri-cpu-line", color: "secondary" },
};

export const articles: Article[] = [
  {
    id: "1",
    title: "某知名互联网大厂裁员30%：内部员工爆料管理层决策内幕",
    slug: "tech-giant-layoff-30-percent-insider-reveal",
    excerpt: "据多位内部员工证实，该公司在未提前通知的情况下突然宣布大规模裁员，涉及多个核心业务部门。知情人士透露，这背后与董事会近期的战略调整密切相关。",
    content: "据多位内部员工证实，该公司在未提前通知的情况下突然宣布大规模裁员，涉及多个核心业务部门。知情人士透露，这背后与董事会近期的战略调整密切相关。\n\n据悉，此次裁员主要涉及人工智能、云计算和电商三大业务线。有员工表示，HR在周五下午突然发出会议邀请，随后在10分钟内完成了裁员通知和离职手续。\n\n一位不愿透露姓名的中层管理人员向51黑料网透露：「这次裁员其实早在三个月前就已经在董事会层面决定了，只是一直压着没有公布。核心原因是公司在新业务方向上的战略摇摆，导致大量项目被砍。」\n\n该消息一经曝光，立即在社交媒体引发热议。不少网友对公司在经济下行期的做法表示质疑，认为应当承担更多社会责任。\n\n截至发稿，该公司官方尚未对此事做出正式回应。51黑料网将持续关注事件进展。",
    category: "social",
    coverImage: "https://readdy.ai/api/search-image?query=Abstract%20modern%20office%20building%20at%20dusk%20with%20warm%20amber%20light%20reflections%20on%20glass%20windows%2C%20dramatic%20atmosphere%2C%20corporate%20aesthetic%2C%20clean%20architectural%20photography%20with%20soft%20shadows%2C%20editorial%20style%2C%20minimalist%20composition&width=800&height=500&seq=article-cvr-01&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-28",
    viewCount: 128500,
    likeCount: 3247,
    isFeatured: true,
    isHot: true,
  },
  {
    id: "2",
    title: "顶流明星深夜密会神秘女子：知情人士曝光时间线",
    slug: "top-celebrity-secret-date-timeline-exposed",
    excerpt: "近日有网友在三亚某豪华酒店拍到某顶流男星与一名神秘女子共度三天两夜。知情人向51黑料网提供了详细的时间线和多张实拍照片。",
    content: "近日有网友在三亚某豪华酒店拍到某顶流男星与一名神秘女子共度三天两夜。知情人向51黑料网提供了详细的时间线和多张实拍照片。\n\n据知情人透露，该男星于6月25日晚间独自入住酒店，随后一名女子从地下车库直接进入其房间。两人在接下来的三天内极少离开房间，餐食均由酒店服务人员送至门口。\n\n值得注意的是，该男星此前一直对外宣称单身，其经纪团队也多次在公开场合强调他「专注事业、无心恋爱」。此次爆料如果属实，将对其人设造成重大冲击。\n\n目前该男星的粉丝群体已经出现分裂，一部分选择相信偶像，另一部分则要求其出面澄清。多个品牌方也表示正在密切关注事态发展。\n\n51黑料网将持续跟进此事，为读者带来第一手消息。",
    category: "entertainment",
    coverImage: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20exterior%20at%20night%20in%20tropical%20location%20with%20palm%20trees%20silhouette%2C%20warm%20ambient%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20photography%20style%2C%20soft%20depth%20of%20field%2C%20elegant%20composition&width=800&height=500&seq=article-cvr-02&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-27",
    viewCount: 356200,
    likeCount: 8912,
    isFeatured: true,
    isHot: true,
  },
  {
    id: "3",
    title: "5G-A商用加速：三大运营商暗战背后不为人知的博弈",
    slug: "5g-advanced-commercial-telecom-battle",
    excerpt: "随着5G-A技术标准正式冻结，三大运营商纷纷加速布局。然而51黑料网独家获悉，这背后涉及到频谱资源、设备采购和基站选址的多方博弈。",
    content: "随着5G-A技术标准正式冻结，三大运营商纷纷加速布局。然而51黑料网独家获悉，这背后涉及到频谱资源、设备采购和基站选址的多方博弈。\n\n据业内人士透露，某运营商在南方某省的5G-A基站建设招标中出现了异常低价竞争，中标价格仅为正常市场价的40%。这引发了行业内的广泛质疑，认为可能存在不正当竞争行为。\n\n此外，在频谱分配方面，三大运营商之间的矛盾也日益公开化。有消息称，某运营商高层在内部会议上直言「不能再让步了」，矛头直指另一家竞争对手。\n\n产业链上下游企业也在密切关注这一动向，因为运营商的设备采购策略将直接影响数百家供应商的生存状况。",
    category: "tech",
    coverImage: "https://readdy.ai/api/search-image?query=Futuristic%20telecommunication%20tower%20with%20glowing%20data%20streams%2C%20abstract%20network%20connections%2C%20warm%20amber%20and%20gold%20tones%2C%20sleek%20modern%20design%2C%20digital%20technology%20aesthetic%2C%20clean%20minimal%20background%2C%20professional%20photography&width=800&height=500&seq=article-cvr-03&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-26",
    viewCount: 89200,
    likeCount: 1563,
    isFeatured: true,
    isHot: true,
  },
  {
    id: "4",
    title: "某省会城市住建局副局长被带走调查：涉土地出让利益链",
    slug: "city-official-investigation-land-corruption",
    excerpt: "据多位消息人士证实，某省会城市住建局副局长于上周五被纪检监察部门带走调查，初步怀疑与多宗土地出让违规操作有关。",
    content: "据多位消息人士证实，某省会城市住建局副局长于上周五被纪检监察部门带走调查，初步怀疑与多宗土地出让违规操作有关。\n\n知情人士向51黑料网透露，该副局长在任期间分管城市更新和土地出让工作，其被调查的主要原因是涉嫌在多宗地块出让过程中收受开发商巨额贿赂。\n\n「涉及的金额可能在数千万级别，」一位接近调查组的人士表示，「目前已经有多家开发商的相关人员被要求配合调查。」\n\n该事件在当地政商界引发震动，多个在建项目的审批进度也因此受到影响。有开发商表示，已经收到通知要求暂停部分工程。",
    category: "social",
    coverImage: "https://readdy.ai/api/search-image?query=Government%20building%20exterior%20with%20dramatic%20overcast%20sky%2C%20serious%20atmosphere%2C%20institutional%20architecture%2C%20clean%20lines%2C%20editorial%20photography%20style%2C%20subdued%20warm%20tones%2C%20professional%20composition&width=800&height=500&seq=article-cvr-04&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-26",
    viewCount: 215000,
    likeCount: 5678,
    isFeatured: false,
    isHot: true,
  },
  {
    id: "5",
    title: "知名女星离婚内幕曝光：千万财产分割方案细节流出",
    slug: "actress-divorce-settlement-details-leaked",
    excerpt: "娱乐圈又一对模范夫妻走到尽头。51黑料网独家获取了双方的财产分割协议草案，涉及房产、股权和品牌代言等多项资产。",
    content: "娱乐圈又一对模范夫妻走到尽头。51黑料网独家获取了双方的财产分割协议草案，涉及房产、股权和品牌代言等多项资产。\n\n根据流出的文件显示，双方名下的共同财产总价值超过1.2亿元，其中包括北京、上海和三亚的5处房产，以及两家文化传媒公司的股权。\n\n值得关注的是，女方名下多个国际品牌的代言合同也被列入分割范围。根据协议草案，女方需要将其中三个品牌代言后续两年的收入的30%支付给男方。\n\n双方目前均未对此事公开发声，但各自的社交媒体已经停止了互动。粉丝群体对此事的反应也相当激烈。",
    category: "entertainment",
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20luxury%20interior%20with%20golden%20lighting%2C%20sophisticated%20atmosphere%2C%20soft%20dramatic%20shadows%2C%20high-end%20residential%20aesthetic%2C%20editorial%20photography%20with%20warm%20tones%2C%20refined%20composition&width=800&height=500&seq=article-cvr-05&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-25",
    viewCount: 189700,
    likeCount: 4230,
    isFeatured: false,
    isHot: true,
  },
  {
    id: "6",
    title: "华为被曝秘密研发新型芯片架构：性能或超高通骁龙两代",
    slug: "huawei-secret-chip-architecture-rumor",
    excerpt: "独家消息：华为海思团队正在研发一款全新的芯片架构，据内部人士透露，该芯片在特定场景下的性能表现已超越高通最新旗舰平台两代以上。",
    content: "独家消息：华为海思团队正在研发一款全新的芯片架构，据内部人士透露，该芯片在特定场景下的性能表现已超越高通最新旗舰平台两代以上。\n\n这则消息来自于一位接近华为海思研发团队的知情人士。据其透露，新架构采用了全新的指令集设计思路，在AI计算和图形渲染方面有突破性的性能提升。\n\n「团队在过去18个月里几乎是封闭式开发，」该人士表示，「华为为此投入了超过2000名工程师和巨额资金。」\n\n如果该消息属实，这将成为中国芯片行业的一个重要里程碑。不过也有行业分析师提醒，从实验室到量产还有很长的路要走，不宜过度乐观。",
    category: "tech",
    coverImage: "https://readdy.ai/api/search-image?query=Futuristic%20microchip%20with%20glowing%20circuit%20patterns%2C%20abstract%20technology%20background%2C%20warm%20golden%20and%20copper%20tones%2C%20clean%20minimal%20design%2C%20high-tech%20aesthetic%2C%20professional%20product%20photography%2C%20soft%20lighting&width=800&height=500&seq=article-cvr-06&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-24",
    viewCount: 167800,
    likeCount: 2876,
    isFeatured: false,
    isHot: true,
  },
  {
    id: "7",
    title: "某网红奶茶品牌被曝使用过期原料：内部员工实拍视频流出",
    slug: "milk-tea-brand-expired-ingredients-exposed",
    excerpt: "一段由内部员工拍摄的视频显示，某知名网红奶茶品牌的后厨存在大量过期原材料，部分原料已发霉变质，却依然被用于制作饮品。",
    content: "一段由内部员工拍摄的视频显示，某知名网红奶茶品牌的后厨存在大量过期原材料，部分原料已发霉变质，却依然被用于制作饮品。\n\n该视频拍摄于该品牌位于某二线城市的加盟门店。视频中可以清晰看到标注生产日期为2025年11月的奶精粉仍在使用，而保质期仅为6个月。\n\n更令人震惊的是，视频还拍到店员在处理已经发霉的水果时，只是简单削去表面霉斑，剩余的果肉继续用于制作水果茶。\n\n食品安全专家在接受51黑料网采访时表示，这种行为已经涉嫌违反《食品安全法》多项条款，消费者完全有权要求赔偿。",
    category: "social",
    coverImage: "https://readdy.ai/api/search-image?query=Abstract%20dark%20kitchen%20scene%20with%20dramatic%20lighting%2C%20shadowy%20atmosphere%2C%20food%20safety%20theme%2C%20warm%20dim%20light%2C%20mysterious%20mood%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=500&seq=article-cvr-07&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-24",
    viewCount: 298400,
    likeCount: 10234,
    isFeatured: false,
    isHot: true,
  },
  {
    id: "8",
    title: "综艺节目录制现场发生争执：两位导师因选手问题翻脸",
    slug: "tv-show-fight-between-mentors",
    excerpt: "某热门音乐选秀节目录制现场突发状况，两位导师因一名选手的晋级问题产生激烈争执，导致录制中断近两小时。",
    content: "某热门音乐选秀节目录制现场突发状况，两位导师因一名选手的晋级问题产生激烈争执，导致录制中断近两小时。\n\n据现场观众描述，当时选手表演结束后，两位导师给出了截然不同的评价。一位导师认为该选手「天赋异禀、值得力捧」，另一位则直言「基本功太差、不适合晋级」。\n\n争执随后升级，双方从专业讨论演变为人身攻击。一位导师甚至当场表示「如果不让他晋级，我就退出这个节目」。\n\n节目组工作人员表示，这种情况在录制历史上尚属首次，导演组正在紧急协调处理方案。",
    category: "entertainment",
    coverImage: "https://readdy.ai/api/search-image?query=Television%20studio%20stage%20with%20dramatic%20spotlights%2C%20entertainment%20show%20atmosphere%2C%20warm%20golden%20and%20amber%20lighting%2C%20theatrical%20mood%2C%20professional%20broadcast%20aesthetic%2C%20clean%20composition&width=800&height=500&seq=article-cvr-08&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-23",
    viewCount: 145200,
    likeCount: 2104,
    isFeatured: false,
    isHot: false,
  },
  {
    id: "9",
    title: "OpenAI被曝正在研发下一代模型：内部代号\"Orion\"参数规模超万亿",
    slug: "openai-next-gen-model-orion-rumor",
    excerpt: "据多位知情人士透露，OpenAI正在研发代号为\"Orion\"的下一代大语言模型，参数规模可能超过万亿级别，预计将带来质的飞跃。",
    content: "据多位知情人士透露，OpenAI正在研发代号为\"Orion\"的下一代大语言模型，参数规模可能超过万亿级别，预计将带来质的飞跃。\n\n消息人士称，Orion项目已经秘密研发了一年多，团队规模超过500人。该模型在设计思路上与当前的GPT系列有根本性差异，采用了全新的混合架构。\n\n「这不仅仅是参数量的简单堆叠，」一位接近该项目的AI研究员表示，「Orion在推理能力和多模态理解方面都有革命性的突破。」\n\n不过也有业内人士保持谨慎态度，认为在当前AI监管趋严的背景下，OpenAI可能不会急于发布新模型，而是会选择更稳妥的节奏。",
    category: "tech",
    coverImage: "https://readdy.ai/api/search-image?query=Abstract%20artificial%20intelligence%20visualization%20with%20glowing%20neural%20networks%2C%20futuristic%20technology%20theme%2C%20warm%20golden%20and%20amber%20energy%20streams%2C%20clean%20minimal%20aesthetic%2C%20professional%20tech%20style%2C%20soft%20atmospheric%20lighting&width=800&height=500&seq=article-cvr-09&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-23",
    viewCount: 98200,
    likeCount: 1876,
    isFeatured: false,
    isHot: false,
  },
  {
    id: "10",
    title: "某二线城市烂尾楼业主集体维权：开发商资金链断裂内幕",
    slug: "unfinished-building-owners-protest",
    excerpt: "上百名业主聚集在某二线城市市政府门前，抗议其购买的楼盘已烂尾超过三年。51黑料网获取了开发商资金链断裂的内部文件。",
    content: "上百名业主聚集在某二线城市市政府门前，抗议其购买的楼盘已烂尾超过三年。51黑料网获取了开发商资金链断裂的内部文件。\n\n根据获取的内部财务数据显示，该开发商在2023年初就已经出现严重的资金周转问题，但直到2024年底仍在公开销售该项目的期房，涉及购房者超过600户。\n\n一位维权业主代表表示：「我们每月既要还房贷，又要付房租，很多家庭已经到了崩溃的边缘。开发商和监管部门都应该对此负责。」\n\n目前该市政府已成立专班介入处理，但具体的解决方案尚未公布。",
    category: "social",
    coverImage: "https://readdy.ai/api/search-image?query=Incomplete%20construction%20site%20with%20unfinished%20concrete%20buildings%2C%20overcast%20sky%2C%20dramatic%20atmosphere%2C%20urban%20landscape%2C%20editorial%20photography%2C%20warm%20muted%20tones%2C%20documentary%20style&width=800&height=500&seq=article-cvr-10&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-22",
    viewCount: 176500,
    likeCount: 4021,
    isFeatured: false,
    isHot: false,
  },
  {
    id: "11",
    title: "网红主播偷税案后续：补缴税款加罚款总额破纪录",
    slug: "influencer-tax-evasion-record-penalty",
    excerpt: "继去年某头部主播因偷逃税被查处后，最新税务稽查又爆出新进展。据悉，此次涉及的主播数量和补缴金额均创下行业纪录。",
    content: "继去年某头部主播因偷逃税被查处后，最新税务稽查又爆出新进展。据悉，此次涉及的主播数量和补缴金额均创下行业纪录。\n\n根据51黑料网获取的信息，此次被查处的网络主播超过30人，集中在直播电商和娱乐打赏两个领域。其中单人最高补缴税款及罚款合计超过8000万元。\n\n税务部门通过大数据分析发现了这些主播通过阴阳合同、拆分收入、虚构成本等方式偷逃税款的线索。\n\n行业内部人士表示，这次行动将对整个直播行业的合规经营产生深远影响。",
    category: "social",
    coverImage: "https://readdy.ai/api/search-image?query=Abstract%20financial%20concept%20with%20documents%20and%20calculator%2C%20warm%20golden%20lighting%2C%20serious%20business%20atmosphere%2C%20clean%20professional%20aesthetic%2C%20editorial%20style%2C%20soft%20shadows&width=800&height=500&seq=article-cvr-11&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-21",
    viewCount: 203100,
    likeCount: 6543,
    isFeatured: false,
    isHot: true,
  },
  {
    id: "12",
    title: "某著名歌手被曝隐婚生子：粉丝后援会内部群聊截图流出",
    slug: "singer-secret-marriage-child-exposed",
    excerpt: "51黑料网独家获取了某著名歌手粉丝后援会的内部群聊截图。截图中，核心粉丝疑似已经知道该歌手隐婚生子的消息，并商议如何应对。",
    content: "51黑料网独家获取了某著名歌手粉丝后援会的内部群聊截图。截图中，核心粉丝疑似已经知道该歌手隐婚生子的消息，并商议如何应对。\n\n截图显示，粉丝后援会核心成员在一个名为「内部事务讨论」的微信群中激烈讨论。有成员表示「早就知道了，只是一直帮忙瞒着」，还有成员担心「如果爆出来，代言起码要掉一半」。\n\n该歌手自出道以来一直以「单身贵族」形象示人，拥有大量女友粉。如果隐婚生子的消息属实，其商业价值将受到严重影响。\n\n目前该歌手及其经纪团队尚未对此做出任何回应。",
    category: "entertainment",
    coverImage: "https://readdy.ai/api/search-image?query=Abstract%20concert%20stage%20with%20warm%20spotlights%20and%20bokeh%20effects%2C%20music%20performance%20atmosphere%2C%20soft%20golden%20tones%2C%20elegant%20composition%2C%20editorial%20photography%20style%2C%20mysterious%20mood&width=800&height=500&seq=article-cvr-12&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-20",
    viewCount: 322800,
    likeCount: 7890,
    isFeatured: false,
    isHot: false,
  },
  {
    id: "13",
    title: "苹果汽车项目重启传闻：库克亲自主导秘密团队曝光",
    slug: "apple-car-project-restart-tim-cook",
    excerpt: "多名供应链人士向51黑料网透露，苹果公司已经在秘密重启汽车项目，并由CEO库克亲自挂帅。新项目代号\"Titan II\"，目标直指2028年量产。",
    content: "多名供应链人士向51黑料网透露，苹果公司已经在秘密重启汽车项目，并由CEO库克亲自挂帅。新项目代号\"Titan II\"，目标直指2028年量产。\n\n据供应链消息，苹果已经与三家亚洲供应商签订了保密协议，涉及电池、电机和车载芯片领域。与之前的Titan项目不同，Titan II更加聚焦在软件和用户体验层面。\n\n「苹果不打算自己造车，而是要做汽车界的iOS，」一位接近该项目的分析师表示，「他们的目标是打造一个开放的智能座舱平台，让传统车企成为硬件代工厂。」\n\n这一战略如果成功，将彻底改变整个汽车行业的格局。",
    category: "tech",
    coverImage: "https://readdy.ai/api/search-image?query=Futuristic%20concept%20car%20in%20dark%20studio%2C%20sleek%20minimalist%20design%2C%20warm%20ambient%20lighting%20highlights%2C%20technology%20innovation%20theme%2C%20clean%20professional%20product%20photography%2C%20soft%20atmospheric%20glow&width=800&height=500&seq=article-cvr-13&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-19",
    viewCount: 145600,
    likeCount: 2345,
    isFeatured: false,
    isHot: false,
  },
  {
    id: "14",
    title: "某上市公司财报造假疑云：审计机构突然宣布辞任",
    slug: "listed-company-financial-fraud-auditor-quit",
    excerpt: "某A股上市公司在年报披露前夕突发公告，称审计机构已辞任。51黑料网获悉，审计机构在核查过程中发现了重大财务数据异常。",
    content: "某A股上市公司在年报披露前夕突发公告，称审计机构已辞任。51黑料网获悉，审计机构在核查过程中发现了重大财务数据异常。\n\n据知情人士透露，审计机构在核查该公司2025年度财务数据时，发现其海外业务收入存在严重问题。该公司声称的海外客户中，有多家公司的注册地址实际上是空壳地址。\n\n「收入确认存在明显的循环交易痕迹，」一位财务专业人士在分析了公开数据后告诉51黑料网，「这种手法在财务造假案件中非常典型。」\n\n证监会已经开始对该公司进行非正式调查，投资者需要保持高度警惕。",
    category: "social",
    coverImage: "https://readdy.ai/api/search-image?query=Abstract%20financial%20charts%20and%20stock%20market%20data%2C%20dramatic%20lighting%2C%20serious%20business%20atmosphere%2C%20warm%20amber%20tones%2C%20professional%20editorial%20style%2C%20clean%20composition&width=800&height=500&seq=article-cvr-14&orientation=landscape",
    author: "51黑料编辑部",
    publishedAt: "2026-06-18",
    viewCount: 112300,
    likeCount: 1987,
    isFeatured: false,
    isHot: false,
  },
];

export const featuredArticles = articles.filter((a) => a.isFeatured);
export const hotArticles = articles.filter((a) => a.isHot);
export const latestArticles = [...articles].sort(
  (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
);

export const initialComments: Comment[] = [
  {
    id: "cmt-1",
    articleId: "1",
    author: "吃瓜群众老王",
    authorAvatar: null,
    content: "早就听说这家公司要裁员，没想到规模这么大...打工人太难了",
    createdAt: "2026-06-28 14:32",
    likes: 156,
  },
  {
    id: "cmt-2",
    articleId: "1",
    author: "互联网老兵",
    authorAvatar: null,
    content: "作为业内人士说一句，这次裁员其实早有征兆。去年Q4开始很多项目就被叫停了，只是管理层一直压着消息。",
    createdAt: "2026-06-28 15:10",
    likes: 203,
  },
  {
    id: "cmt-3",
    articleId: "1",
    author: "匿名用户A",
    authorAvatar: null,
    content: "我在里面工作，周五下午收到会议邀请的时候整个人都懵了。HR效率高得吓人，10分钟全部搞定。",
    createdAt: "2026-06-28 16:45",
    likes: 389,
  },
  {
    id: "cmt-4",
    articleId: "2",
    author: "娱乐追光者",
    authorAvatar: null,
    content: "天哪不会是真的吧？我家哥哥不是一直说专注事业吗😭",
    createdAt: "2026-06-27 19:22",
    likes: 92,
  },
  {
    id: "cmt-5",
    articleId: "2",
    author: "理性吃瓜人",
    authorAvatar: null,
    content: "说句公道话，明星也是人，谈恋爱结婚不是正常的吗？粉丝别太玻璃心了。",
    createdAt: "2026-06-27 20:05",
    likes: 478,
  },
  {
    id: "cmt-6",
    articleId: "2",
    author: "三亚本地通",
    authorAvatar: null,
    content: "那家酒店我住过，隐私确实做得好，地下车库客人根本碰不到。啧啧，熟门熟路啊。",
    createdAt: "2026-06-27 21:18",
    likes: 267,
  },
  {
    id: "cmt-7",
    articleId: "3",
    author: "通信行业观察",
    authorAvatar: null,
    content: "5G-A这块蛋糕太大了，三家谁都不想放手。低价竞标这种事在通信行业其实很常见。",
    createdAt: "2026-06-26 10:30",
    likes: 134,
  },
  {
    id: "cmt-8",
    articleId: "3",
    author: "数码爱好者",
    authorAvatar: null,
    content: "不管他们怎么斗，对消费者来说5G-A网速提升是实实在在的。期待早日用上！",
    createdAt: "2026-06-26 11:15",
    likes: 88,
  },
  {
    id: "cmt-9",
    articleId: "7",
    author: "食品安全卫士",
    authorAvatar: null,
    content: "奶茶行业早该管管了！我之前就在一家网红奶茶店打工，后厨情况比这个还夸张。",
    createdAt: "2026-06-24 09:42",
    likes: 567,
  },
  {
    id: "cmt-10",
    articleId: "7",
    author: "奶茶控小美",
    authorAvatar: null,
    content: "看到这个真的后怕...以后只喝白开水了。求问是哪家品牌啊？",
    createdAt: "2026-06-24 10:08",
    likes: 234,
  },
  {
    id: "cmt-11",
    articleId: "7",
    author: "前餐饮从业者",
    authorAvatar: null,
    content: "加盟店品控确实是大问题，品牌方只管收加盟费，实际运营根本没人监管。",
    createdAt: "2026-06-24 11:20",
    likes: 312,
  },
  {
    id: "cmt-12",
    articleId: "4",
    author: "体制内观察者",
    authorAvatar: null,
    content: "最近反腐力度明显加大了，这种级别的官员被查已经不是第一起了。拭目以待后续。",
    createdAt: "2026-06-26 16:55",
    likes: 445,
  },
  {
    id: "cmt-13",
    articleId: "4",
    author: "本地居民",
    authorAvatar: null,
    content: "终于查到他了！我们小区旁边那个项目拖了三年就是因为他在中间搞事情。大快人心！",
    createdAt: "2026-06-26 17:30",
    likes: 598,
  },
  {
    id: "cmt-14",
    articleId: "6",
    author: "芯片工程师",
    authorAvatar: null,
    content: "作为从业者谨慎看待这个消息。芯片架构从设计到流片再到量产，每一步都是巨大的挑战。",
    createdAt: "2026-06-24 14:22",
    likes: 189,
  },
  {
    id: "cmt-15",
    articleId: "6",
    author: "科技博主小林",
    authorAvatar: null,
    content: "如果消息属实，这确实是中国半导体行业的重要里程碑。不过还是要等官方消息。",
    createdAt: "2026-06-24 15:40",
    likes: 167,
  },
  {
    id: "cmt-16",
    articleId: "12",
    author: "资深瓜农",
    authorAvatar: null,
    content: "哈哈后援会内部群截图都流出来了，这波实锤了。粉丝们集体塌房现场。",
    createdAt: "2026-06-20 12:10",
    likes: 723,
  },
  {
    id: "cmt-17",
    articleId: "12",
    author: "前站姐",
    authorAvatar: null,
    content: "追了他三年，有些事情其实圈内人都知道，只是大家心照不宣而已。",
    createdAt: "2026-06-20 13:05",
    likes: 512,
  },
  {
    id: "cmt-18",
    articleId: "11",
    author: "税务从业者",
    authorAvatar: null,
    content: "8000万...这个数字在网红圈也算天花板了。大数据查税真的让很多灰色操作无所遁形。",
    createdAt: "2026-06-21 08:30",
    likes: 298,
  },
  {
    id: "cmt-19",
    articleId: "14",
    author: "小股民心声",
    authorAvatar: null,
    content: "我就买了这家公司的股票！已经亏了40%了，现在才知道原来是财务造假...",
    createdAt: "2026-06-18 20:15",
    likes: 876,
  },
  {
    id: "cmt-20",
    articleId: "10",
    author: "维权业主代表",
    authorAvatar: null,
    content: "三年了，每个月既要还贷又要租房，很多家庭已经撑不住了。希望这次报道能让政府加速处理。",
    createdAt: "2026-06-22 09:10",
    likes: 945,
  },
];